export { PARTNER } from "./partner";

export type { PartnerType } from "./partner";
